<template>
  <v-navigation-drawer 
    class="elevation-5"
    app
    clipped
    width="170px"
  >
        <!-- Date -->
        <h4 class="mt-6 mb-4 primary--text text-center">
          {{ currentDate }}, <br/>
          {{ currentDay }}
        </h4>
        
        <!-- doctor's schedule -->
        <sidebar-schedules></sidebar-schedules>
  </v-navigation-drawer>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'AppSidebar',

    components: {
      SidebarSchedules: () => import('./SidebarSchedules.vue')
    },

    data: () => ({
      //
    }),

    computed: {
      currentDate() {
        return moment().format("MMM D")
        // const now = new Date();
        // return now.toLocaleString('default', { month: 'short', day: 'numeric' });
      },
      currentDay() {
        return moment().format('ddd');    
        // const now = new Date();
        // return now.toLocaleString('default', { weekday: 'short' });
      },
    },

    methods: {
      //
    }
  }
</script>

<style lang="scss" scoped>

</style>